<template>
  <b-tab v-bind:title="notificationTabLabel">
    <b-form-checkbox v-model="notificationSettings[0].enabled" switch>
      {{ fuelConsumptionSensorVerificationNotificationLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[0].notificationDelay"
        :disabled="!notificationSettings[0].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationBeforeNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[0].notificationBefore"
        :disabled="!notificationSettings[0].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationStartNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        v-model="notificationSettings[0].notificationStartEnabledTime"
        :disabled="!notificationSettings[0].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationEndNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        v-model="notificationSettings[0].notificationEndEnabledTime"
        :disabled="!notificationSettings[0].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <hr />
    <b-form-checkbox v-model="notificationSettings[1].enabled" switch>
      {{ fuelLevelSensorVerificationNotificationLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[1].notificationDelay"
        :disabled="!notificationSettings[1].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationBeforeNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[1].notificationBefore"
        :disabled="!notificationSettings[1].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationStartNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        v-model="notificationSettings[1].notificationStartEnabledTime"
        :disabled="!notificationSettings[1].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationEndNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        v-model="notificationSettings[1].notificationEndEnabledTime"
        :disabled="!notificationSettings[1].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <hr />
    <b-form-checkbox v-model="notificationSettings[2].enabled" switch>
      {{ maxFuelHeightNotificationLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[2].notificationDelay"
        :disabled="!notificationSettings[2].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <hr />
    <b-form-checkbox v-model="notificationSettings[3].enabled" switch>
      {{ minFuelHeightNotificationLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[3].notificationDelay"
        :disabled="!notificationSettings[3].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <hr />
    <b-form-checkbox v-model="notificationSettings[4].enabled" switch>
      {{ maxWaterHeightNotificationLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[4].notificationDelay"
        :disabled="!notificationSettings[4].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <hr />
    <b-form-checkbox v-model="notificationSettings[5].enabled" switch>
      {{ minWaterHeightNotificationLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[5].notificationDelay"
        :disabled="!notificationSettings[5].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <hr />
    <b-form-checkbox v-model="notificationSettings[6].enabled" switch>
      {{ chargeNotificationLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[6].notificationDelay"
        :disabled="!notificationSettings[6].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationStartNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        v-model="notificationSettings[6].notificationStartEnabledTime"
        :disabled="!notificationSettings[6].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationEndNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        v-model="notificationSettings[6].notificationEndEnabledTime"
        :disabled="!notificationSettings[6].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <hr />
    <b-form-checkbox v-model="notificationSettings[7].enabled" switch>
      {{ openedHatchOfFuelTankNotificationLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[7].notificationDelay"
        :disabled="!notificationSettings[7].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationStartNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        v-model="notificationSettings[7].notificationStartEnabledTime"
        :disabled="!notificationSettings[7].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationEndNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        no-flip
        v-model="notificationSettings[7].notificationEndEnabledTime"
        :disabled="!notificationSettings[7].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <hr />
    <b-form-checkbox v-model="notificationSettings[8].enabled" switch>
      {{ chargeShelfNotificationLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="notificationSettings[8].notificationDelay"
        :disabled="!notificationSettings[8].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationStartNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        v-model="notificationSettings[8].notificationStartEnabledTime"
        :disabled="!notificationSettings[8].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="fuelLevelSensorVerificationEndNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-timepicker
        min="0"
        size="sm"
        placeholder=""
        locale="ru"
        v-model="notificationSettings[8].notificationEndEnabledTime"
        :disabled="!notificationSettings[8].enabled"
        style="font-size: 13px"
      ></b-form-timepicker>
    </b-form-group>
    <hr />
    <b-form-checkbox v-model="notificationSettings[9].enabled" switch>
      {{ criticalFuelLevelLabel }}
    </b-form-checkbox>
    <hr />
    <b-form-checkbox v-model="notificationSettings[10].enabled" switch>
      {{ alarmFuelLevelLabel }}
    </b-form-checkbox>
    <hr />
    <b-form-checkbox v-model="notificationSettings[11].enabled" switch>
      {{ noFuelDataLabel }}
    </b-form-checkbox>
    <b-form-group
      label-cols-sm="9"
      label-cols-lg="9"
      content-cols-sm
      content-cols-lg="9"
      v-bind:label="noFuelDataDelayNotificationLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="noFuelDataPeriod"
        :disabled="!notificationSettings[11].enabled"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
  </b-tab>
</template>

<script>
import { utilsService } from "../../../services";

export default {
  name: "NotificationSettingsTab",
  props: {
    fuelTankCard: Object,
  },
  data() {
    return {
      notificationSettings: [],
      DEFAULT_NOTIFICATION_DELAY_SEC: 300,
      noFuelDataPeriod: 0,
    };
  },
  computed: {
    notificationTabLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationTabLabel;
    },
    fuelConsumptionSensorVerificationNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[0].label;
    },
    fuelLevelSensorVerificationNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[1].label;
    },
    fuelLevelSensorVerificationBeforeNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationLabels.beforeNotificationLabel;
    },
    fuelLevelSensorVerificationDelayNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationLabels.delayNotificationLabel;
    },
    fuelLevelSensorVerificationStartNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationLabels.startNotificationLabel;
    },
    fuelLevelSensorVerificationEndNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationLabels.endNotificationLabel;
    },
    noFuelDataDelayNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationLabels.delayUpdateFuelDataLabel;
    },
    maxFuelHeightNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[2].label;
    },
    minFuelHeightNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[3].label;
    },
    maxWaterHeightNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[4].label;
    },
    minWaterHeightNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[5].label;
    },
    chargeNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[6].label;
    },
    openedHatchOfFuelTankNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[7].label;
    },
    chargeShelfNotificationLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[8].label;
    },
    criticalFuelLevelLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[9].label;
    },
    alarmFuelLevelLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[10].label;
    },
    noFuelDataLabel() {
      return this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings[11].label;
    },
  },
  created() {
    for (
      let i = 0;
      i <
      this.$store.state.localization.data.mainPage.fuelTankCard
        .notificationSettings.length;
      i++
    ) {
      this.notificationSettings.push({
        enabled: false,
        notificationDelay: this.DEFAULT_NOTIFICATION_DELAY_SEC,
        notificationBefore: 0,
        notificationStartEnabledTime: "",
        notificationEndEnabledTime: "",
      });

      const notificationSetting = this.fuelTankCard.notificationSettings.find(
        (x) => x.notificationType == i + 1
      );

      if (notificationSetting) {
        this.notificationSettings[i].enabled = true;
        this.notificationSettings[i].notificationDelay =
          notificationSetting.notificationDelay;
        this.notificationSettings[i].notificationBefore =
          notificationSetting.notificationBefore / 86400;
        this.notificationSettings[i].notificationStartEnabledTime =
          utilsService.convertFromSecondsTohhmmss(
            notificationSetting.notificationStartEnabledTime
          );

        this.notificationSettings[i].notificationEndEnabledTime =
          utilsService.convertFromSecondsTohhmmss(
            notificationSetting.notificationEndEnabledTime
          );

        let settings = null;
        if (notificationSetting.notificationSettings) {
          settings = JSON.parse(notificationSetting.notificationSettings);
        }
        if (notificationSetting.notificationType == 12) {
          this.noFuelDataPeriod = settings.noFuelDataPeriod;
        }
      } else {
        if (i == 0 || i == 1) {
          this.notificationSettings[i].notificationStartEnabledTime =
            utilsService.convertFromSecondsTohhmmss(9 * 60 * 60);

          this.notificationSettings[i].notificationEndEnabledTime =
            utilsService.convertFromSecondsTohhmmss(10 * 60 * 60);
        }
      }
    }
  },
  methods: {
    getNotificationSettings() {
      const notificationSettings = [];

      for (let i = 0; i < this.notificationSettings.length; i++) {
        if (this.notificationSettings[i].enabled) {
          const notificationSetting = {
            notificationType: i + 1,
            notificationDelay: parseInt(
              this.notificationSettings[i].notificationDelay
            ),
            notificationBefore:
              86400 * parseInt(this.notificationSettings[i].notificationBefore),
            notificationStartEnabledTime:
              utilsService.convertFromhhmmssToSeconds(
                this.notificationSettings[i].notificationStartEnabledTime
              ),
            notificationEndEnabledTime: utilsService.convertFromhhmmssToSeconds(
              this.notificationSettings[i].notificationEndEnabledTime
            ),
          };

          if (notificationSetting.notificationType == 12) {
            notificationSetting.notificationSettings = JSON.stringify({
              noFuelDataPeriod: parseInt(this.noFuelDataPeriod),
            });
          }

          notificationSettings.push(notificationSetting);
        }
      }

      return notificationSettings;
    },
  },
};
</script>
